import { useEffect } from "react";

function upsert(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attrs.tag);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => {
    if (k === "tag") return;
    if (k === "text") el.textContent = v;
    else el.setAttribute(k, v);
  });
  return el;
}

export default function useSEO({ title, description, canonical }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsert('meta[name="description"]', { tag: "meta", name: "description", content: description });
      upsert('meta[property="og:description"]', { tag: "meta", property: "og:description", content: description });
    }
    if (title) {
      upsert('meta[property="og:title"]', { tag: "meta", property: "og:title", content: title });
    }
    if (canonical) {
      upsert('link[rel="canonical"]', { tag: "link", rel: "canonical", href: canonical });
    }
  }, [title, description, canonical]);
}
